import React from 'react';
import SalesIndex from '../impact';

export default function () {
  return <SalesIndex noFixedVideo noExitIntent noShareButtons ctaOverride="sales97" ctaNoTimer variant="ad-ik" />;
}
